"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findById = exports.sample = exports.toggleInArray = exports.first = exports.last = void 0;
function last(array) {
    return array[array.length - 1];
}
exports.last = last;
function first(array) {
    return array[0];
}
exports.first = first;
/**
 * Removes a value from an array if it's present. Adds it if it isn't present.
 */
function toggleInArray(array, value) {
    if (array.includes(value)) {
        return array.filter(other => other !== value);
    }
    return [...array, value];
}
exports.toggleInArray = toggleInArray;
/**
 * Returns a random value from an array. Returns `undefined` if the array is empty.
 */
function sample(array) {
    const { length } = array;
    if (length === 0) {
        return undefined;
    }
    return array[Math.floor(Math.random() * length)];
}
exports.sample = sample;
/**
 * Finds a value in an array by its `id` field. Returns `undefined` if nothing is found.
 */
function findById(array, id) {
    return array.find(value => value.id === id);
}
exports.findById = findById;
//# sourceMappingURL=arrayUtils.js.map